import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
`;

export const Main = styled.main`
  background-color: ${(props) =>
    props.darkBackdrop ? "var(--background)" : "var(--white)"};
  padding: var(--outsidePadding);
  width: 100%;
  & > h2 {
    margin: 0 0 var(--outsidePadding);
    font-family: var(--headerFont);
    font-weight: normal;
    text-transform: uppercase;
    letter-spacing: 0.8px;
  }
  & > div > ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    font-family: var(--headerFont);
    & > li {
      display: inline-block;
      &:after {
        content: "·";
        margin-left: 8px;
        margin-right: 8px;
      }
      &:last-of-type {
        &:after {
          content: "";
        }
      }
      & a {
        text-decoration: none;
        color: var(--text);
        transition: 0.5s;
        font-weight: bold;
        &:hover {
          color: var(--highlight);
          text-decoration: underline;
        }
      }
    }
  }
`;

export const FooterDiv = styled.footer`
  height: var(--footerHeight);
  display: flex;
  padding: var(--outsidePadding);
  background-color: var(--background);
  justify-content: center;
  border-top: 1px solid var(--rule);
  align-items: center;
  & p a {
    color: var(--text);
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;
